import { render } from "./SimulationsPage.vue?vue&type=template&id=5fa1d864&ts=true"
import script from "./SimulationsPage.vue?vue&type=script&lang=ts"
export * from "./SimulationsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__